// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper__Eg_oI","slider":"Slider_slider__uT04F","showOverflow":"Slider_showOverflow__qVPTe","slide":"Slider_slide__ulHtt","dots":"Slider_dots__cTJGw"};